// Angular
import {
  CommonModule
} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup
} from '@angular/forms';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';

// Local library
import { DepositAddAccountService, IAccountACH } from '@amwager/funding/data-access';
import { UnsubscribeObservableService,
  TranslatePipe
} from '@amwager/util';

// Third party
import {
  Subscription,
  takeUntil
} from 'rxjs';

@Component({
  selector: 'feature-mat-add-account',
  templateUrl: './add-account.component.html',
  styleUrls: ['./add-account.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositAddAccountService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddAccountComponent extends UnsubscribeObservableService implements OnInit {

  private subsAddAccountResponse!: Subscription;
  tmsId?: string;
  addAccountForm!: FormGroup;
  isAgree: boolean = false;
  isProcessing: boolean = false;
  @Output() showAddAccountFormFn = new EventEmitter<boolean>();

  // convenience getter for easy access to form fields
  get formVal() { return this.addAccountForm?.controls }

  isOnline: boolean = true;

  constructor(
    private readonly addAccountService: DepositAddAccountService,
  ) {
    super();

  }

  ngOnInit() {
    this.checkConnectivity();
    this.observerTmsIds();

    // OLD (form creation + routing/account validators moved to DepositAddAccountService.buildForm):
    // this.initForm();
    // this.addAccountForm.get('routingName')?.valueChanges.subscribe(...);
    // this.addAccountForm.get('accountNumber')?.valueChanges.subscribe(...);
    this.addAccountForm = this.addAccountService.buildForm();
  }

  private observerTmsIds(): void {
    // OLD (moved to DepositAddAccountService.tmsId$):
    // this.commonFacade?.tmsId$()
    this.addAccountService.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  addAccount(): void {
    if (!this.isOnline) {
      // OLD (moved to DepositAddAccountService.setOffline):
      // this.commonFacade.setIsConnectedInternet('AddAccountComponent:addAccount', false);
      this.addAccountService.setOffline('AddAccountComponent:addAccount');
      return;
    }

    if (this.addAccountForm.valid && this.isAgree) {

      this.isProcessing = true;

      const accountACH: IAccountACH = {
        AchAccount: this.addAccountForm.get('accountNumber')?.value,
        AchRoute: this.addAccountForm.get('routingName')?.value,
        AchAccounttype: this.addAccountForm.get('accountType')?.value,
        AccountId: 0,
        AchName: this.addAccountForm.get('bankName')?.value,
      }
      this.isAgree = false;

      // OLD (dispatch + success stream moved to DepositAddAccountService.addAccount$):
      // this.fundingFacade.addAccountACH(accountACH);
      // this.subsAddAccountResponse = this.fundingFacade.isAddAchAccountSuccess$()
      this.subsAddAccountResponse = this.addAccountService.addAccount$(accountACH)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {

        if (isSuccess) {

          this.addAccountForm.reset();

          // OLD (moved to DepositAddAccountService.refreshAccounts):
          // this.fundingFacade.getAchAccount();
          this.addAccountService.refreshAccounts();

          this.isProcessing = false;
          this.showAddAccountFormFn.emit(true);

          this.subsAddAccountResponse?.unsubscribe();
          return;
        }

        if (isSuccess !== undefined && isSuccess === false) {
          this.isProcessing = false;
          this.showAlertMessage('Error', response?.error?.Message);
          this.subsAddAccountResponse?.unsubscribe();
          return;
        }

      });

    }
  }

  closeForm(): void {
    this.showAddAccountFormFn.emit(true);
  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to DepositAddAccountService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.addAccountService.showAlert(header, message);
  }

  checkConnectivity(): void {
    // OLD (moved to DepositAddAccountService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'AddAccountComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.addAccountService.checkConnectivity(
      'AddAccountComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
